import PropTypes from 'prop-types';
import React from 'react';
import s from './WorkTracker.module.scss';
import { taskShape } from './propTypes';
import StatusSelect from './StatusSelect';
import { dueLabel, dueTone, railTone } from './lib/dates';
import { progressOf } from './lib/sorting';

export default function TaskCard({
  task, today, open, dragging, dragHandleProps, innerRef, draggableProps, onOpen, onStatus,
}) {
  const tone = dueTone(task, today);
  const progress = task.status === 'complete' ? null : progressOf(task);
  const comments = (task.comments || []).length;
  return (
    <div
      ref={innerRef}
      {...draggableProps}
      className={s.row}
      data-rail={railTone(task, today)}
      data-open={open ? 'true' : undefined}
      data-dragging={dragging ? 'true' : undefined}
      onClick={() => onOpen(task)}
      onKeyDown={(e) => { if (e.key === 'Enter' && e.target === e.currentTarget) onOpen(task); }}
      role="button"
      tabIndex={0}
      aria-label={`Open ${task.title}`}
    >
      <span className={s.grip} {...dragHandleProps} aria-label="Drag to reorder" title="Drag to reorder">⋮⋮</span>
      <div className={s.rowMain}>
        <p className={s.rowTitle}>{task.title}</p>
        <div className={s.meta}>
          {task.due_on && <span className={tone ? s[`due-${tone}`] : ''}>{dueLabel(task, today)}</span>}
          {task.assignee_name && <span>{task.assignee_name}</span>}
          {task.priority === 'high' && <span className={s.pillHigh}>High priority</span>}
          {task.priority === 'low' && <span className={s.pill}>Low priority</span>}
          {comments > 0 && (
          <span>
            {comments}
            {' '}
            comment
            {comments === 1 ? '' : 's'}
          </span>
          )}
        </div>
      </div>
      {progress && (
        <div className={s.progress} aria-label={`Checklist ${progress.done} of ${progress.total} done`}>
          <div className={s.bar}>
            <div className={s.barFill} style={{ width: `${(progress.done / progress.total) * 100}%` }} />
          </div>
          <span>
            {progress.done}
            /
            {progress.total}
          </span>
        </div>
      )}
      <StatusSelect
        value={task.status}
        label={`Status of ${task.title}`}
        onChange={(status) => onStatus(task, status)}
      />
    </div>
  );
}

TaskCard.propTypes = {
  task: taskShape.isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
  open: PropTypes.bool,
  dragging: PropTypes.bool,
  dragHandleProps: PropTypes.objectOf(PropTypes.any),
  draggableProps: PropTypes.objectOf(PropTypes.any),
  innerRef: PropTypes.func,
  onOpen: PropTypes.func.isRequired,
  onStatus: PropTypes.func.isRequired,
};
TaskCard.defaultProps = {
  open: false, dragging: false, dragHandleProps: undefined, draggableProps: undefined, innerRef: undefined,
};
